import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import DataLight from '../../data/data_light_.csv';

class BudgetChart extends React.Component {
  constructor(props) {
    super(props);
    this.renderLight = this.renderLight.bind(this);
    this.renderRank = this.renderRank.bind(this);
    this.renderName = this.renderName.bind(this);
    this.renderBarChart = this.renderBarChart.bind(this);
  }
  renderLight() {
    const lightName = DataLight[22];
    return (
      <div className="light-block">
        <div className="light-title">
          <div className="title">
            {lightName[`${this.props.budget.category}`]}
          </div>
          <div className="title">
            {lightName.hasOwnProperty(`${this.props.budget.category}-2`) ?
            lightName[`${this.props.budget.category}-2`] : null}
          </div>
          <div className="title">
            {lightName.hasOwnProperty(`${this.props.budget.category}-3`) ?
            lightName[`${this.props.budget.category}-3`] : null}
          </div>
        </div>
        <div className="light-content">
          {DataLight.map((country) =>
            <div className="light" key={`light-${country.name}`}>
              <i
                className={`circle
                -${country[`${this.props.budget.category}`].toLowerCase()}`}
              />
              {country.hasOwnProperty(`${this.props.budget.category}-2`) ?
                <i
                  className={`circle
                  -${country[`${this.props.budget.category}-2`].toLowerCase()}`}
                /> : null}
              {country.hasOwnProperty(`${this.props.budget.category}-3`) ?
                <i
                  className={`circle
                  -${country[`${this.props.budget.category}-3`].toLowerCase()}`}
                /> : null}
            </div>
          )}
        </div>
      </div>
    );
  }
  renderRank() {
    return (
      <div className="rank-block">
        <div className="rank-title">支出順位</div>
        <div className="rank-content">
          {this.props.budget.data.map((country) =>
            <div
              className="rank"
              key={`rank-${country.name}`}
            >
              {country[`${this.props.budget.category}-rank`]}
            </div>
          )}
        </div>
      </div>
    );
  }
  renderName() {
    return (
      <div className="name-block">
        {this.props.budget.data.map((country) =>
          <div className="name" key={`name-${country.name}`}>{country.name}</div>
        )}
      </div>
    );
  }
  renderBarChart() {
    const isLargeScreen = window.matchMedia('(min-width: 992px)').matches;
    const dataToShow = this.props.budget.data;
    const nanFilter = (d) => {
      const result = isNaN(parseFloat(d)) ? 0 : parseFloat(d);
      return result;
    };
    const rank1Budget = Math.max.apply(Math, dataToShow.map((country) =>
      nanFilter(country[`${this.props.budget.category}`])
    ));
    const numberWithCommas = (x) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return (
      <div className="bar-chart">
        <div className="chart-title">{this.props.budget.categoryTitle}</div>
        {dataToShow.map((country) =>
          <div
            className="bar"
            key={`bar-${country.name}`}
          >
            <div
              className="body"
              style={isLargeScreen ? {
                height:
                `${nanFilter(country[`${this.props.budget.category}`]) / rank1Budget * 250}px`,
              } : {
                width:
                `${nanFilter(country[`${this.props.budget.category}`]) / rank1Budget * 50}%`,
              }}
            >
            </div>
            <div className="number">
              {numberWithCommas(country[`${this.props.budget.category}`])}
            </div>
          </div>
        )}
      </div>
    );
  }
  render() {
    return (
      <div className="main-chart">
        {this.renderLight()}
        {this.renderRank()}
        {this.renderName()}
        {this.renderBarChart()}
      </div>
    );
  }
}

BudgetChart.propTypes = {
  budget: PropTypes.object,
};

function mapStateToProps(state) {
  return { budget: state.budget };
}

export default connect(mapStateToProps, null)(BudgetChart);



/** WEBPACK FOOTER **
 ** ./src/components/budget-chart.js
 **/